import { ArrowUpIcon } from './ArrowUpIcon';

/**
 * author: Austin Andrews
 * id 3AF49B97-A909-4961-9FBB-82C60D7CC773
 * name arrow-up
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-up.svg
 * tags
 * - Arrow 
 */
export const ArrowUpwardIcon = ArrowUpIcon;
export default ArrowUpwardIcon